import React, { useCallback, useState } from 'react';
import { isEmpty } from '../../../utils';
import { Menu, message, Modal, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import qs from 'qs';
import { HttpStatusCode } from '../../../fetch/core/constant';
import { NoSignalInterSectionStatus } from '../../../redux/type';
import ControlCommandApi from '../../../fetch/bussiness/control';
const controlCommand = new ControlCommandApi();
import { clstagStr } from '../../../utils/util';
import { CLSTAG } from '../../../utils/constant';
import { TakeOverStatus } from '@/views/PatrolMode/types';
interface Props {
  isStoped: boolean;
  disabled: boolean;
  takeOverStatus: string;
  operatorIsSelf: boolean | undefined;
  onShowMessage: (param: 'TRAFFIC_LIGHT') => void;
}

let timer: any = null;
const PassTrafficLightButton = (props: Props) => {
  const { isStoped, operatorIsSelf, disabled, takeOverStatus } = props;
  const singleVehiclePageInfo = useSelector(
    (state: RootState) => state.singleVehiclePageInfo
  );
  const { trafficLightData, noSignalIntersectionData } = singleVehiclePageInfo;
  const { trafficLightIdList, passLightAvailable } = trafficLightData;
  const { status } = noSignalIntersectionData;
  const [visible, setVisible] = useState(false);
  // passLightAvailable : null , false , true
  // 红绿灯路口
  const isTraficLightIntersection = !isEmpty(trafficLightIdList);
  // 无保护左转路口
  const isNoSignalIntersection = [
    NoSignalInterSectionStatus.READY,
    NoSignalInterSectionStatus.RUNNING,
  ].includes(status);
  let isEnabled =
    isStoped && (isTraficLightIntersection || isNoSignalIntersection);
  // 当有人正在接管中并且不是自己的时候禁用按钮
  if (operatorIsSelf === false) {
    isEnabled = false;
  }

  if (passLightAvailable === false) {
    isEnabled = true;
  }
  if (takeOverStatus === TakeOverStatus.TEMPORARY) {
    isEnabled = false;
  }
  if (disabled) {
    isEnabled = false;
  }
  const handleCountDown = () => {
    const interval = setInterval(() => {
      const el = document.getElementById('cancleBtn');
      if (el) {
        clearInterval(interval);
        const countDown = (count: number) => {
          timer = setTimeout(() => {
            clearTimeout(timer);
            if (count === 0) {
              setVisible(false);
              return;
            }
            count--;
            el.innerText = `取消(${count}s)`;
            countDown(count);
          }, 1000);
        };
        countDown(8);
      }
    }, 200);
  };

  // 通过路口逻辑 - 与PassTrafficLight组件保持一致
  const handlePassTrafficLight = () => {
    if (!isEnabled) {
      return;
    }
    if (passLightAvailable === false) {
      onOk();
    } else {
      props.onShowMessage('TRAFFIC_LIGHT');
      setVisible(true);
      handleCountDown();
    }
  };

  const onOk = useCallback(() => {
    if (isTraficLightIntersection) {
      handleSendTraficLightCommand();
    } else if (isNoSignalIntersection) {
      handleControlNoSignalIntersection();
    }
    setVisible(false);
    clearTimeout(timer);
  }, [trafficLightIdList, passLightAvailable, noSignalIntersectionData]);

  const handleSendTraficLightCommand = () => {
    const query = qs.parse(window.location.search.split('?')[1]);
    const vehicleName = query && query.license;
    controlCommand
      .sendTraficLightCommand({
        vehicleName: vehicleName,
        timeStamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        trafficLightId: trafficLightIdList,
        passThrough: passLightAvailable === false ? false : true,
      })
      .then((res: any) => {
        if (res.code === HttpStatusCode.Success) {
          message.success('指令已下发');
        } else {
          message.success(res.message);
        }
      });
  };

  const handleControlNoSignalIntersection = () => {
    const query = qs.parse(window.location.search.split('?')[1]);
    const vehicleName = query && query.license;
    controlCommand
      .controlNoSignalIntersection({
        vehicleName: vehicleName,
        timeStamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        groupLaneIdList: noSignalIntersectionData.groupLaneIdList,
      })
      .then((res: any) => {
        if (res.code === HttpStatusCode.Success) {
          message.success('指令已下发');
        } else {
          message.success(res.message);
        }
      });
  };
  return (
    <>
      <Tooltip
        title={
          isTraficLightIntersection
            ? `当前路口所有灯：${
                !isEmpty(trafficLightIdList)
                  ? trafficLightIdList.toString()
                  : ''
              }`
            : null
        }
      >
        <Menu.Item
          key="3"
          disabled={!isEnabled}
          onClick={handlePassTrafficLight}
          clstag={
            passLightAvailable
              ? clstagStr(CLSTAG.PassTrafficLightBtnClick)
              : clstagStr(CLSTAG.CancelTrafficLightBtnClick)
          }
          style={{
            color: !isEnabled ? 'rgb(150 150 150)' : undefined,
            cursor: !isEnabled ? 'not-allowed' : 'pointer',
          }}
        >
          {passLightAvailable === false ? '取消通过' : '通过路口'}
        </Menu.Item>
      </Tooltip>
      <Modal
        destroyOnHidden={true}
        className="pass-light-confirm"
        closable={true}
        maskClosable={false}
        onCancel={() => {
          setVisible(false);
          clearTimeout(timer);
        }}
        visible={visible}
        footer={
          <div className="footer-btn-group">
            <span
              className="cancle-btn"
              id="cancleBtn"
              onClick={() => {
                setVisible(false);
                clearTimeout(timer);
              }}
            >
              取消(8s)
            </span>
            <span
              className="ok-btn"
              onClick={() => {
                onOk();
              }}
            >
              确定
            </span>
          </div>
        }
      >
        <div className="message-content">
          {isTraficLightIntersection ? (
            <>
              请检查当前路口所看灯与路口红绿灯id是否一致。
              <br />
              您是否确定立即通过当前路口？
            </>
          ) : (
            <>当前路口为无保护左转路口，您是否确定通过当前路口？</>
          )}
        </div>
      </Modal>
    </>
  );
};

export default PassTrafficLightButton;
